import React from 'react'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from './Loader'
import Navbar from "./Navbar";
import Header from './Header'
import Footer from './Footer'
import BoardApprovedCont from './container/BoardApprovedCont';
function BoardApproved() {
    const location = useLocation();

    useEffect(() => {
        const menuToggle = document.getElementById("sidebar-hide");
        const sidebar = document.querySelector(".pc-sidebar");
        if (!menuToggle) return;

        const toggleSidebar = () => {
            sidebar.classList.toggle("pc-sidebar-hide");
        };

        menuToggle.addEventListener("click", toggleSidebar);

        return () => {
            menuToggle.removeEventListener("click", toggleSidebar);
        };
    }, [location.pathname]);
    return (
        <div>
            <Loader />
            <Navbar />
            <Header />
            <BoardApprovedCont />
            <Footer />
        </div>
    )
}

export default BoardApproved